import { useEffect, useRef, useState } from "react";
import {
    FaCalendarAlt,
    FaCheckCircle,
    FaEdit,
    FaFileCsv,
    FaHome,
    FaPlus,
    FaSignOutAlt,
    FaThLarge,
    FaTrash,
    FaTimes,
    FaSave,
    FaImages,
    FaUpload,
    FaMapMarkerAlt
} from "react-icons/fa";

import { Link } from "react-router-dom";
import API_BASE_URL from "../config";
import "./css/AdminManageVillas.css";

function AdminManageVillas() {
    // ==========================================================
    // 1. STATE MANAGEMENT UTAMA
    // ==========================================================
    const [villas, setVillas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    const [relatedRooms, setRelatedRooms] = useState([]);
    const [activeTab, setActiveTab] = useState("villa-info");

    const fileInputRef = useRef(null);
    const roomFileInputRef = useRef(null);
    const singleImageUploadRef = useRef(null);

    // State dinamis galeri gambar admin
    const [uploadedImagesInFE, setUploadedImagesInFE] = useState([]);

    const [form, setForm] = useState({
        id: "", name: "", location: "", mitra_name: "-", whatsapp: "-",
        price: "", rating: "5", guests: "4", beds: "2", baths: "1",
        bed_type: "1 King Size", check_in_time: "14:00", check_out_time: "12:00", status: "available", img: "utama.png",
        room_count: "1", bathroom_type: "-", hours: "-", description: "", amenities: "", equipment: "", facilities: "", promo: "0"
    });

    const [selectedRoomIndex, setSelectedRoomIndex] = useState("");
    const [roomForm, setRoomForm] = useState({
        id: "",
        bed_info: "",
        room_type: "Standard Room",
        price: "",
        facilities: "",
        snk: "",
        description: "",
        img: "room_1_1.png",
        max_guests: "",
        max_age_rule: "",
        other_facilities: "",
        room_count: "",
        bathroom_count: "",
        bathroom_type: "",
        amenities: "",
        equipment: "",
        hours: ""
    });

    // State untuk Layanan Tambahan (Addon)
    const [addonList, setAddonList] = useState([]);
    const [addonEditIndex, setAddonEditIndex] = useState(null);
    const [addonForm, setAddonForm] = useState({ addon_type: "Motor", name: "", price: "", description: "" });

    // ==========================================================
    // 2. FETCH DATA DARI FLASK BACKEND
    // ==========================================================
    const fetchVillas = () => {
        fetch(`${API_BASE_URL}/api/admin/villas`)
            .then((res) => {
                if (!res.ok) throw new Error("Gagal mengambil data");
                return res.json();
            })
            .then((resData) => {
                const dataArr = resData.data || resData;
                if (Array.isArray(dataArr)) {
                    setVillas(dataArr);
                }
            })
            .catch((err) => console.error("Error fetch data villa:", err));
    };

    const fetchRelatedRooms = async (villaId) => {
        if (!villaId) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/admin/villa-details?villa_id=${villaId}`);
            if (res.ok) {
                const dataRes = await res.json();
                const roomList = dataRes.data || dataRes;
                setRelatedRooms(Array.isArray(roomList) ? roomList : []);
            } else {
                setRelatedRooms([]);
            }
        } catch (error) {
            console.error("Gagal memuat data kamar terkait:", error);
            setRelatedRooms([]);
        }
    };

    useEffect(() => {
        if (showModal && form.id && activeTab === "rooms-info") {
            fetchRelatedRooms(form.id);
        }
    }, [activeTab, showModal, form.id]);

    useEffect(() => {
        fetchVillas();
    }, []);

    // ==========================================================
    // 3. HANDLER INPUT & SINKRONISASI GAMBAR otomatis
    // ==========================================================
    const openAddModal = async () => {
        setEditIndex(null);
        setRelatedRooms([]);
        setActiveTab("villa-info");
        
        let tempId = Math.floor(1000 + Math.random() * 9000).toString();
        try {
            const res = await fetch(`${API_BASE_URL}/api/admin/villas/next_id`);
            if (res.ok) {
                const data = await res.json();
                if (data.next_id) {
                    tempId = data.next_id.toString();
                }
            }
        } catch (e) {
            console.error("Gagal mendapatkan next_id", e);
        }

        setForm({
            id: tempId, name: "", location: "", mitra_name: "-", whatsapp: "-",
            price: "", rating: "5", guests: "4", beds: "2", baths: "1",
            bed_type: "1 King Size", check_in_time: "14:00", check_out_time: "12:00", status: "available", img: "utama.png",
            room_count: "1", bathroom_type: "-", hours: "-", description: "", amenities: "", equipment: "", facilities: "", promo: "0"
        });
        resetRoomForm();
        setShowModal(true);
    };

    const openEditModal = (index) => {
        setEditIndex(index);
        setActiveTab("villa-info");
        const selectedVilla = villas[index];
        const targetId = selectedVilla.id || selectedVilla._id || "";

        // Mengatur default nama gambar agar sesuai nama villa (permintaan user)
        let defaultImg = selectedVilla.img;
        if (!defaultImg || defaultImg === "default_mitra.jpg" || defaultImg === "utama.png") {
            const safeName = (selectedVilla.name || "Villa").replace(/[^a-zA-Z0-9\-_ ]/g, '');
            defaultImg = `${safeName}.jpg`;
        }

        setForm({
            id: targetId,
            name: selectedVilla.name || "",
            location: selectedVilla.location || "",
            mitra_name: selectedVilla.mitra_name || "-",
            whatsapp: selectedVilla.whatsapp || "-",
            price: selectedVilla.price || "",
            rating: selectedVilla.rating || "5",
            guests: (selectedVilla.guests && selectedVilla.guests !== '-') ? selectedVilla.guests : "",
            beds: (selectedVilla.beds && selectedVilla.beds !== '-') ? selectedVilla.beds : "",
            baths: (selectedVilla.baths && selectedVilla.baths !== '-') ? selectedVilla.baths : "",
            bed_type: (selectedVilla.bed_type && selectedVilla.bed_type !== '-') ? selectedVilla.bed_type : "",
            check_in_time: selectedVilla.check_in_time || "14:00",
            check_out_time: selectedVilla.check_out_time || "12:00",
            status: selectedVilla.status || "available",
            img: defaultImg,
            room_count: (selectedVilla.room_count && selectedVilla.room_count !== '-') ? selectedVilla.room_count : "",
            bathroom_type: (selectedVilla.bathroom_type && selectedVilla.bathroom_type !== '-') ? selectedVilla.bathroom_type : "",
            hours: (selectedVilla.hours && selectedVilla.hours !== '-') ? selectedVilla.hours : "",
            description: selectedVilla.description || "",
            amenities: selectedVilla.amenities || "",
            equipment: selectedVilla.equipment || "",
            facilities: selectedVilla.facilities || "",
            promo: selectedVilla.promo || "0"
        });

        resetRoomForm();
        fetchRelatedRooms(targetId);
        setShowModal(true);
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleRoomChange = (e) => {
        const { name, value } = e.target;
        setRoomForm(prev => ({ ...prev, [name]: value }));
    };

    const resetRoomForm = () => {
        setSelectedRoomIndex("");
        setAddonList([]);
        setAddonEditIndex(null);
        setAddonForm({ addon_type: "Motor", name: "", price: "", description: "" });
        setRoomForm({
            id: "",
            bed_info: "",
            room_type: "Standard Room",
            price: "",
            facilities: "",
            snk: "",
            description: "",
            img: "room_1_1.png",
            max_guests: "",
            max_age_rule: "",
            other_facilities: "",
            room_count: "",
            bathroom_count: "",
            bathroom_type: "",
            amenities: "",
            equipment: "",
            hours: "",
            location: ""
        });
    };

    const fetchAddons = async (roomId) => {
        if (!roomId) return;
        try {
            // Ambil addons dari endpoint villa detail yang sudah menyertakan addons per room
            const res = await fetch(`${API_BASE_URL}/api/villas/${form.id}`);
            if (res.ok) {
                const data = await res.json();
                const rooms = data.rooms || [];
                const room = rooms.find(r => String(r.id_detail) === String(roomId));
                setAddonList(room ? (room.addons || []) : []);
            }
        } catch (e) {
            console.error("Gagal load addon:", e);
            setAddonList([]);
        }
    };

    const saveAddon = async () => {
        const currentRoomId = roomForm.id;
        if (!currentRoomId) { alert("Simpan data kamar terlebih dahulu sebelum menambahkan layanan tambahan."); return; }
        if (!addonForm.name.trim()) { alert("Nama layanan tidak boleh kosong."); return; }
        try {
            let url = `${API_BASE_URL}/api/admin/room-addons`;
            let method = "POST";
            const body = { ...addonForm, room_id: currentRoomId, price: parseInt(addonForm.price) || 0 };
            if (addonEditIndex !== null) {
                const editId = addonList[addonEditIndex].id;
                url = `${API_BASE_URL}/api/admin/room-addons/${editId}`;
                method = "PUT";
            }
            const res = await fetch(url, { method, headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
            if (!res.ok) throw new Error("Gagal menyimpan addon");
            alert(addonEditIndex !== null ? "Layanan diperbarui!" : "Layanan berhasil ditambahkan!");
            setAddonForm({ addon_type: "Motor", name: "", price: "", description: "" });
            setAddonEditIndex(null);
            fetchAddons(currentRoomId);
        } catch (e) {
            alert("Error: " + e.message);
        }
    };

    const deleteAddon = async (addonId) => {
        if (!window.confirm("Hapus layanan tambahan ini?")) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/admin/room-addons/${addonId}`, { method: "DELETE" });
            if (!res.ok) throw new Error();
            fetchAddons(roomForm.id);
        } catch (e) {
            alert("Gagal menghapus layanan.");
        }
    };

    const loadRoomToForm = async (index) => {
        if (index === "") {
            resetRoomForm();
            return;
        }
        const target = relatedRooms[index];
        setSelectedRoomIndex(index);

        const roomId = target.id || target.id_detail || target._id;
        const isGenericFallback = !target.img || target.img === "room_1_1.png" || target.img === "default_room.jpg";
        
        let dbImage = target.img || target.image || target.room_name;
        if (isGenericFallback || (dbImage && !dbImage.endsWith(".png") && !dbImage.endsWith(".jpg"))) {
            const rawRoomName = target.bed_info || target.room_name || "Kamar";
            const safeRoomName = rawRoomName.replace(/[^a-zA-Z0-9\-_ ]/g, '');
            dbImage = `${safeRoomName}.jpg`;
        }

        setRoomForm({
            id: roomId || "",
            bed_info: target.bed_info || "",
            room_type: target.room_type || "Standard Room",
            price: target.price || target.price_raw || "",
            facilities: target.facilities || "",
            snk: target.snk || "-",
            description: target.description || "",
            img: dbImage,
            max_guests: target.max_guests || "",
            max_age_rule: target.max_age_rule || "",
            other_facilities: target.other_facilities || "",
            room_count: target.room_count || "",
            bathroom_count: target.bathroom_count || "",
            bathroom_type: target.bathroom_type || "",
            amenities: target.amenities || "",
            equipment: target.equipment || "",
            hours: target.hours || "",
            location: target.location || ""
        });

        // Ambil daftar gambar FISIK asli dari server untuk menjamin semua foto (termasuk .jpg) tampil
        try {
            const res = await fetch(`${API_BASE_URL}/api/admin/gallery?villa_id=${form.id || '1'}&folder_type=room&room_id=${roomId}`);
            if (res.ok) {
                const data = await res.json();
                let realImages = data.data || [];
                
                // Jika API mengembalikan gambar nyata, gunakan gambar pertama sebagai gambar aktif
                // agar tidak terjebak pada nama file lama dari DB yang sudah tidak ada
                if (realImages.length > 0) {
                    // Cek apakah dbImage benar-benar ada di folder (case-insensitive check)
                    const dbImageExists = realImages.some(f => f.toLowerCase() === dbImage?.toLowerCase());
                    if (!dbImageExists) {
                        // Nama di DB sudah stale/tidak cocok → pakai gambar pertama dari folder
                        dbImage = realImages[0];
                        setRoomForm(prev => ({ ...prev, img: dbImage }));
                    }
                } else if (dbImage) {
                    // Belum ada file di subfolder, tambahkan nama dari DB sebagai hint
                    realImages = [dbImage];
                }
                setUploadedImagesInFE(realImages);
            } else {
                throw new Error("Gagal load galeri fisik");
            }
        } catch (e) {
            console.error(e);
            setUploadedImagesInFE(dbImage ? [dbImage] : []);
        }

        // Ambil daftar layanan tambahan untuk kamar ini
        fetchAddons(roomId);
    };

    // ==========================================================
    // 4. CRUD ACTIONS (SAVE VILLA, SAVE ROOM, DELETE)
    // ==========================================================
    const saveVilla = async () => {
        if (!form.name || !form.location) {
            alert("Mohon isi data wajib");
            return;
        }
        try {
            let response = editIndex !== null
                ? await fetch(`${API_BASE_URL}/api/admin/villas/${form.id}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form) })
                : await fetch(`${API_BASE_URL}/api/admin/villas`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form) });

            if (response.ok) {
                alert("Data induk Villa berhasil disimpan!");
                setShowModal(false);
                fetchVillas();
            }
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

    const saveRoomData = async () => {
        if (!roomForm.bed_info) {
            alert("Nama unit (Bed Info) wajib diisi!");
            return;
        }

        const safeFallbackName = roomForm.bed_info.replace(/[^a-zA-Z0-9\-_ ]/g, '');
        const chosenImage = roomForm.img || `${safeFallbackName}.jpg`;

        const payloadData = {
            villa_id: parseInt(form.id),
            bed_info: roomForm.bed_info,
            room_name: roomForm.bed_info,
            room_type: roomForm.room_type || "Standard Room",
            price: roomForm.price ? parseInt(roomForm.price) : 0,
            facilities: roomForm.facilities || "",
            img: chosenImage,
            image: chosenImage,
            description: roomForm.description || "",
            max_guests: roomForm.max_guests || "",
            max_age_rule: roomForm.max_age_rule || "",
            other_facilities: roomForm.other_facilities || "",
            snk: roomForm.snk || "",
            room_count: roomForm.room_count || "",
            bathroom_count: roomForm.bathroom_count || "",
            bathroom_type: roomForm.bathroom_type || "",
            amenities: roomForm.amenities || "",
            equipment: roomForm.equipment || "",
            hours: roomForm.hours || "",
            location: roomForm.location || ""
        };

        try {
            let response;
            if (selectedRoomIndex === "") {
                response = await fetch(`${API_BASE_URL}/api/admin/villa-details`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payloadData)
                });
            } else {
                response = await fetch(`${API_BASE_URL}/api/admin/villa-details/${roomForm.id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...payloadData, id: roomForm.id, id_detail: roomForm.id })
                });
            }

            if (response.ok) {
                alert("Data unit dan relasi foto berhasil disimpan ke database! 🚀");
                resetRoomForm();
                fetchRelatedRooms(form.id);
            } else {
                const errData = await response.json();
                alert(`Gagal: ${errData.error || 'Periksa koneksi Flask'}`);
            }
        } catch (error) {
            console.error("Error saving room:", error);
        }
    };

    const deleteRoomData = async (roomId) => {
        if (!window.confirm("Apakah Anda yakin ingin menghapus unit ini?")) return;
        try {
            const response = await fetch(`${API_BASE_URL}/api/admin/villa-details/${roomId}`, { method: "DELETE" });
            if (response.ok) {
                alert("Unit berhasil dihapus!");
                fetchRelatedRooms(form.id);
                resetRoomForm();
            }
        } catch (error) {
            console.error("Gagal menghapus kamar:", error);
        }
    };

    const deleteVilla = async (index) => {
        const selectedVilla = villas[index];
        if (window.confirm(`Apakah Anda yakin ingin menghapus ${selectedVilla.name}?`)) {
            try {
                const response = await fetch(`${API_BASE_URL}/api/admin/villas/${selectedVilla.id}`, { method: "DELETE" });
                if (response.ok) {
                    alert("Villa berhasil dihapus!");
                    fetchVillas();
                }
            } catch (error) {
                console.error("Error deleting data:", error);
            }
        }
    };

    // ==========================================================
    // 5. MANAJEMEN GALERI FOTO (TAMBAH & HAPUS ELEMENT)
    // ==========================================================
    const [isUploading, setIsUploading] = useState(false);

    const uploadImageFile = async (file, villaId, folderType, targetFilename, roomId = null) => {
        setIsUploading(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("villa_id", villaId);
            formData.append("folder_type", folderType);
            formData.append("filename", targetFilename);
            if (roomId) {
                formData.append("room_id", roomId);
            }

            const response = await fetch(`${API_BASE_URL}/api/admin/upload`, {
                method: "POST",
                body: formData
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.error || "Gagal upload gambar");
            }
            return true;
        } catch (error) {
            console.error("Upload error:", error);
            alert(`Error Upload: ${error.message}`);
            return false;
        } finally {
            setIsUploading(false);
        }
    };

    const selectImageFromGallery = (fileName) => {
        setRoomForm(prev => ({ ...prev, img: fileName }));
    };

    const handleSingleImageUpload = async (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const roomId = roomForm.id || "";
            
            // VALIDASI FILE
            const allowedExts = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
            if (!allowedExts.includes(file.type)) {
                alert("❌ Tipe file tidak didukung. Gunakan PNG, JPG, WEBP, atau GIF");
                return;
            }

            if (file.size > 5 * 1024 * 1024) { // 5MB limit
                alert("❌ Ukuran file terlalu besar (max 5MB)");
                return;
            }

            // Generate nama file yang aman dan konsisten
            // Format: image_1.png, image_2.png, dsb
            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            const nextNum = uploadedImagesInFE.length + 1;
            const safeFileName = `image_${nextNum}${ext}`;
            
            const success = await uploadImageFile(file, form.id || '1', "room", safeFileName, roomId);
            
            if (success) {
                if (!uploadedImagesInFE.includes(safeFileName)) {
                    setUploadedImagesInFE([...uploadedImagesInFE, safeFileName]);
                }
                
                // Set sebagai gambar aktif jika ini gambar pertama
                if (uploadedImagesInFE.length === 0) {
                    setRoomForm(prev => ({ ...prev, img: safeFileName }));
                }
                
                alert(`✅ Gambar "${safeFileName}" berhasil diunggah ke server!`);
            }
        }
        // Reset input agar bisa upload file dengan nama sama lagi
        e.target.value = '';
    };

    const removeImageFromGallery = (e, imgName) => {
        e.stopPropagation();
        if (window.confirm(`Hapus gambar "${imgName}" dari server? ⚠️ Ini akan menghapus file secara permanen!`)) {
            deleteImageFromServer(imgName);
        }
    };

    const deleteImageFromServer = async (imgName) => {
        try {
            const roomId = roomForm.id || "";
            const response = await fetch(
                `${API_BASE_URL}/api/admin/gallery?villa_id=${form.id || '1'}&folder_type=room&room_id=${roomId}&filename=${encodeURIComponent(imgName)}`,
                { method: "DELETE" }
            );

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.error || "Gagal hapus gambar");
            }

            const result = await response.json();
            setUploadedImagesInFE(uploadedImagesInFE.filter(item => item !== imgName));
            
            // Jika gambar yang dihapus adalah gambar aktif, pilih gambar lain
            if (roomForm.img === imgName) {
                const remaining = uploadedImagesInFE.filter(item => item !== imgName);
                if (remaining.length > 0) {
                    setRoomForm(prev => ({ ...prev, img: remaining[0] }));
                } else {
                    setRoomForm(prev => ({ ...prev, img: "room_1_1.png" }));
                }
            }

            alert(`✅ Gambar "${imgName}" berhasil dihapus dari server!`);
        } catch (error) {
            console.error("Delete error:", error);
            alert(`❌ Error hapus gambar: ${error.message}`);
        }
    };

    const triggerFileSelect = () => fileInputRef.current.click();
    const triggerRoomFileSelect = () => roomFileInputRef.current.click();

    const handleCSVUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = async (event) => {
            const text = event.target.result;
            const lines = text.split(/\r?\n/);
            let uploadCount = 0;
            for (let i = 1; i < lines.length; i++) {
                const line = lines[i].trim();
                if (!line) continue;
                const columns = line.split(";");
                if (columns.length < 3 || !columns[1] || columns[1].trim() === "") continue;

                const csvData = {
                    id: columns[0].trim(), name: columns[1].trim(), location: columns[2].trim(),
                    whatsapp: columns[3] ? columns[3].trim() : "-", price: 0, rating: "5", guests: "4", beds: "2", baths: "1",
                    bed_type: "Hostel/Villa Utama", check_in_time: "14:00", check_out_time: "12:00", status: "available"
                };
                try {
                    await fetch(`${API_BASE_URL}/api/admin/villas`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(csvData)
                    });
                    uploadCount++;
                } catch (err) { console.error(err); }
            }
            alert(`Sukses mengimpor ${uploadCount} data Mitra.`);
            e.target.value = "";
            fetchVillas();
        };
        reader.readAsText(file);
    };

    const handleRoomCSVUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = async (event) => {
            const text = event.target.result;
            const lines = text.split(/\r?\n/);
            let uploadCount = 0;
            for (let i = 1; i < lines.length; i++) {
                const line = lines[i].trim();
                if (!line) continue;
                const columns = line.split(";");
                if (columns.length < 4 || !columns[1] || columns[1].trim() === "") continue;

                let rawPrice = columns[4] ? columns[4].trim() : "0";
                if (rawPrice.includes("-")) rawPrice = rawPrice.split("-")[0].trim();
                let cleanPrice = parseInt(rawPrice.replace(/\D/g, ""), 10);
                if (isNaN(cleanPrice)) cleanPrice = 0;

                const roomData = {
                    villa_id: columns[1].trim(), bed_info: columns[2].trim(), room_name: columns[2].trim(), room_type: columns[3] ? columns[3].trim() : "Standard Room",
                    price: cleanPrice, facilities: columns[5] ? columns[5].trim() : "-",
                    img: columns[6] ? columns[6].trim() : "room_1_1.png", image: columns[6] ? columns[6].trim() : "room_1_1.png", snk: "-", description: "Nikmati pengalaman nyaman",
                    max_guests: "4", max_age_rule: "Batas maksimal dihitung dari usia 6 Tahun ke atas.", other_facilities: "Fasilitas Tambahan Lengkap"
                };
                try {
                    await fetch(`${API_BASE_URL}/api/admin/villa-details`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(roomData)
                    });
                    uploadCount++;
                } catch (err) { console.error(err); }
            }
            alert(`Sukses mengimpor ${uploadCount} data Kamar.`);
            e.target.value = "";
            if (form.id) fetchRelatedRooms(form.id);
        };
        reader.readAsText(file);
    };

    return (
        <div className="admin-layout">
            <div className="sidebar">
                <div>
                    <div className="sidebar-logo">
                        <img
                            src="/images/logo-jogjavilla.png"
                            alt="Jogja Villa"
                            style={{ height: "40px", objectFit: "contain", filter: "brightness(0) invert(1)" }}
                        />
                    </div>
                    <div className="menu">
                        <Link to="/admin/dashboard" className="menu-item"><FaThLarge /> Dashboard</Link>
                        <Link to="/admin/villas" className="menu-item active"><FaHome /> Kelola Villa</Link>
                        <Link to="/admin/transactions" className="menu-item"><FaCalendarAlt /> Transaksi Pemesanan</Link>
                        <Link to="/admin/payment" className="menu-item"><FaCheckCircle /> Validasi Pembayaran</Link>
                    </div>
                </div>
                <div className="logout"><FaSignOutAlt /> Keluar</div>
            </div>

            <div className="main">
                <div className="topbar">
                    <div>
                        <p className="welcome">Selamat datang kembali,</p>
                        <h2>Admin</h2>
                    </div>
                </div>

                <div className="page-header">
                    <div>
                        <h1>Kelola Villa (Mitra Utama)</h1>
                        <p>Tambah, edit, dan konfigurasi properti serta relasi gambar unit</p>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <input type="file" accept=".csv" ref={fileInputRef} onChange={handleCSVUpload} style={{ display: "none" }} />
                        <button className="import-csv-btn" onClick={triggerFileSelect} style={{ backgroundColor: "#27ae60", color: "white", border: "none", padding: "10px 15px", borderRadius: "6px", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: "600" }}><FaFileCsv /> Import CSV Mitra</button>

                        <input type="file" accept=".csv" ref={roomFileInputRef} onChange={handleRoomCSVUpload} style={{ display: "none" }} />
                        <button className="import-csv-btn" onClick={triggerRoomFileSelect} style={{ backgroundColor: "#2980b9", color: "white", border: "none", padding: "10px 15px", borderRadius: "6px", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: "600" }}><FaFileCsv /> Import CSV Room</button>

                        <button className="add-btn" onClick={openAddModal}><FaPlus /> Tambah Villa</button>
                    </div>
                </div>

                <div className="villa-table">
                    <table>
                        <thead>
                            <tr>
                                <th>ID Mitra</th>
                                <th>Nama Mitra Penginapan</th>
                                <th>Alamat / Lokasi</th>
                                <th>Link WhatsApp Resmi</th>
                                <th>Status</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {villas.map((villa, index) => (
                                <tr key={villa.id || villa._id || index}>
                                    <td>{villa.id}</td>
                                    <td><strong>{villa.name}</strong></td>
                                    <td>{villa.location}</td>
                                    <td>
                                        {villa.whatsapp && villa.whatsapp !== "-" ? (
                                            <a href={villa.whatsapp.startsWith("http") ? villa.whatsapp : `https://wa.me/${villa.whatsapp}`} target="_blank" rel="noreferrer" style={{ color: "#27ae60", fontWeight: "600" }}>Hubungi WA Mitra</a>
                                        ) : ("-")}
                                    </td>
                                    <td><span className={`status ${villa.status || 'available'}`}>{villa.status || 'available'}</span></td>
                                    <td className="actions">
                                        <FaEdit className="edit" style={{ cursor: "pointer", marginRight: "10px", color: "#2980b9" }} onClick={() => openEditModal(index)} />
                                        <FaTrash className="delete" style={{ cursor: "pointer", color: "#e74c3c" }} onClick={() => deleteVilla(index)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay" style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
                    <div className="modal-content" style={{ backgroundColor: "#fff", padding: "25px", borderRadius: "8px", width: "820px", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 4px 15px rgba(0,0,0,0.2)" }}>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px", borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
                            <h2>{editIndex !== null ? `🔧 Pengaturan: ${form.name}` : "➕ Tambah Villa Baru"}</h2>
                            <FaTimes style={{ cursor: "pointer", fontSize: "1.2rem", color: "#666" }} onClick={() => setShowModal(false)} />
                        </div>

                        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                            <button type="button" onClick={() => setActiveTab("villa-info")} style={{ padding: "8px 16px", cursor: "pointer", fontWeight: "bold", border: "none", borderRadius: "4px", backgroundColor: activeTab === "villa-info" ? "#2980b9" : "#fff", color: activeTab === "villa-info" ? "#fff" : "#333" }}>ℹ️ Informasi Dasar Utama</button>
                            <button type="button" onClick={() => setActiveTab("rooms-info")} style={{ padding: "8px 16px", cursor: "pointer", fontWeight: "bold", border: "none", borderRadius: "4px", backgroundColor: activeTab === "rooms-info" ? "#2980b9" : "#fff", color: activeTab === "rooms-info" ? "#fff" : "#333" }}>🛏️ Pilihan Room Kamar ({relatedRooms.length})</button>
                        </div>

                        {activeTab === "villa-info" && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                <label style={{ fontWeight: "bold" }}>Nama Properti *</label>
                                <input type="text" name="name" value={form.name || ""} onChange={handleChange} style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
                                <label style={{ fontWeight: "bold" }}>Alamat / Lokasi *</label>
                                <input type="text" name="location" value={form.location || ""} onChange={handleChange} style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
                                
                                <label style={{ fontWeight: "bold" }}>Status Promo</label>
                                <select name="promo" value={form.promo || "0"} onChange={handleChange} style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}>
                                    <option value="0">Tidak Ada Promo</option>
                                    <option value="1">Sedang Promo 🔥</option>
                                </select>
                                
                                <label style={{ fontWeight: "bold", display: "block", marginTop: "10px", color: "#1e293b" }}><FaImages /> Foto Utama Villa: <span style={{ color: "#2563eb" }}>{form.img || "utama.png"}</span></label>
                                <div style={{ display: "flex", gap: "15px", alignItems: "center", marginBottom: "12px" }}>
                                    <img
                                        src={`/images/villas/villa_${form.id || '1'}/${form.img || "utama.png"}`}
                                        alt="Preview Utama"
                                        onError={(e) => { e.target.src = `/images/villas/villa_1/utama.png`; }}
                                        style={{ width: "100px", height: "70px", objectFit: "cover", borderRadius: "6px", border: "2px solid #2563eb" }}
                                    />
                                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                                        <input type="text" name="img" value={form.img || ""} onChange={handleChange} placeholder="Nama file gambar (cth: utama.png)" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #cbd5e1" }} />
                                        <div>
                                            <input type="file" ref={fileInputRef} onChange={async (e) => {
                                                const file = e.target.files[0];
                                                if(file) {
                                                    const safeFileName = file.name.replace(/[^a-zA-Z0-9.\-_]/g, '');
                                                    const success = await uploadImageFile(file, form.id || '1', "main", safeFileName);
                                                    if (success) {
                                                        setForm(prev => ({...prev, img: safeFileName}));
                                                        alert(`Gambar utama "${safeFileName}" berhasil diunggah ke server!`);
                                                    }
                                                }
                                            }} style={{ display: "none" }} accept="image/*" />
                                            <button type="button" disabled={isUploading} onClick={() => fileInputRef.current.click()} style={{ padding: "8px 12px", backgroundColor: isUploading ? "#94a3b8" : "#27ae60", color: "white", border: "none", borderRadius: "4px", cursor: isUploading ? "not-allowed" : "pointer", display: "inline-flex", alignItems: "center", gap: "5px", fontWeight: "600" }}><FaUpload /> {isUploading ? "Mengunggah..." : "Pilih Gambar Baru"}</button>
                                        </div>
                                    </div>
                                </div>

                                <label style={{ fontWeight: "bold" }}>Nomor WhatsApp Mitra</label>
                                <input type="text" name="whatsapp" value={form.whatsapp || ""} onChange={handleChange} style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
                                
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px", marginTop: "10px" }}>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Kapasitas Peserta</label>
                                        <input type="text" name="guests" value={form.guests || ""} onChange={handleChange} placeholder="Contoh: 15-16 atau 4" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", width: "100%" }} />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Jumlah Kamar</label>
                                        <input type="text" name="room_count" value={form.room_count || ""} onChange={handleChange} placeholder="Contoh: 1" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", width: "100%" }} />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Tipe Kamar (Bed)</label>
                                        <input type="text" name="bed_type" value={form.bed_type || ""} onChange={handleChange} placeholder="Contoh: 1 King Size" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", width: "100%" }} />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Jumlah Kamar Mandi</label>
                                        <input type="text" name="baths" value={form.baths || ""} onChange={handleChange} placeholder="Contoh: 1" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", width: "100%" }} />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Tipe Kamar Mandi</label>
                                        <input type="text" name="bathroom_type" value={form.bathroom_type || ""} onChange={handleChange} placeholder="Dalam/Luar" style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Jam (Operasional)</label>
                                        <input type="text" name="hours" value={form.hours || ""} onChange={handleChange} placeholder="Check-in 14:00..." style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />
                                    </div>
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                    <label style={{ fontWeight: "bold" }}>Deskripsi Kamar / Properti</label>
                                    <textarea name="description" rows="2" value={form.description || ""} onChange={handleChange} style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}></textarea>
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "10px" }}>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Amenities (Pisahkan dgn koma)</label>
                                        <textarea name="amenities" rows="2" value={form.amenities || ""} onChange={handleChange} placeholder="Handuk, Sabun, dll..." style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}></textarea>
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: "bold" }}>Perlengkapan (Pisahkan dgn koma)</label>
                                        <textarea name="equipment" rows="2" value={form.equipment || ""} onChange={handleChange} placeholder="TV, AC, dll..." style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}></textarea>
                                    </div>
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                    <label style={{ fontWeight: "bold" }}>Fasilitas Kamar (Pisahkan dengan Koma)</label>
                                    <input type="text" name="facilities" value={form.facilities || ""} onChange={handleChange} style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />
                                </div>

                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "15px" }}>
                                    <button type="button" onClick={() => setShowModal(false)} style={{ padding: "8px 16px", borderRadius: "4px", border: "1px solid #ccc" }}>Batal</button>
                                    <button type="button" onClick={saveVilla} style={{ padding: "8px 16px", borderRadius: "4px", border: "none", backgroundColor: "#2980b9", color: "#fff" }}>Simpan Data Utama</button>
                                </div>
                            </div>
                        )}

                        {activeTab === "rooms-info" && (
                            <div style={{ paddingBottom: "30px" }}>
                                <label style={{ fontWeight: "bold", display: "block", marginBottom: "8px" }}>Pilih Unit yang Ingin Dikelola / Diedit:</label>

                                <select
                                    value={selectedRoomIndex}
                                    onChange={(e) => loadRoomToForm(e.target.value)}
                                    style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #cbd5e1", backgroundColor: "#fff", fontSize: "1rem", fontWeight: "500", color: "#334155", marginBottom: "25px", cursor: "pointer" }}
                                >
                                    <option value="">➕ -- Tambah Variasi Unit Baru -- </option>
                                    {relatedRooms.map((room, idx) => (
                                        <option key={room.id || room.id_detail || idx} value={idx}>
                                            🛏️ {room.bed_info || "Tanpa Nama"}
                                        </option>
                                    ))}
                                </select>

                                <h3 style={{ marginBottom: "15px", color: "#2980b9", borderBottom: "2px solid #cbd5e1", paddingBottom: "6px" }}>
                                    {selectedRoomIndex !== "" ? `📝 Formulir Edit Unit: ${roomForm.bed_info}` : "➕ Formulir Tambah Unit Baru"}
                                </h3>

                                <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>

                                    {/* GALERI MANAJEMEN SELECTION */}
                                    <div className="gallery-section" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", padding: "15px", borderRadius: "6px" }}>
                                        <label style={{ fontWeight: "bold", display: "block", marginBottom: "8px", color: "#1e293b" }}><FaImages /> Foto Kamar Terpilih: <span style={{ color: "#2563eb" }}>{roomForm.img || "image_1.png"}</span></label>
                                        <div style={{ display: "flex", gap: "15px", alignItems: "center", marginBottom: "12px" }}>
                                            <img
                                                src={roomForm.id ? `/images/villas/villa_${form.id || '1'}/rooms/room_${roomForm.id}/${roomForm.img || "image_1.png"}` : `/images/villas/villa_${form.id || '1'}/rooms/${roomForm.img || "image_1.png"}`}
                                                alt="Preview"
                                                onError={(e) => { e.target.src = `/images/villas/villa_1/rooms/${roomForm.img || "image_1.png"}`; }}
                                                style={{ width: "100px", height: "70px", objectFit: "cover", borderRadius: "6px", border: "2px solid #2563eb" }}
                                            />
                                            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                                                <input type="text" name="img" value={roomForm.img || ""} readOnly style={{ padding: "8px", borderRadius: "4px", border: "1px solid #cbd5e1", backgroundColor: "#f1f5f9" }} />
                                                <div>
                                                    <input type="file" ref={singleImageUploadRef} onChange={handleSingleImageUpload} style={{ display: "none" }} accept="image/*" />
                                                    <button type="button" disabled={isUploading} onClick={() => singleImageUploadRef.current.click()} style={{ padding: "8px 12px", backgroundColor: isUploading ? "#94a3b8" : "#27ae60", color: "white", border: "none", borderRadius: "4px", cursor: isUploading ? "not-allowed" : "pointer", display: "inline-flex", alignItems: "center", gap: "5px", fontWeight: "600" }}><FaUpload /> {isUploading ? "Mengunggah..." : "Tambah Gambar Baru"}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="image-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "12px", maxHeight: "180px", overflowY: "auto", border: "1px solid #cbd5e1", padding: "10px", borderRadius: "6px", backgroundColor: "#fff" }}>
                                            {[...uploadedImagesInFE].map((imgName, i) => {
                                                const targetRoomId = roomForm.id;
                                                return (
                                                <div
                                                    key={i}
                                                    className="gallery-item"
                                                    onClick={() => selectImageFromGallery(imgName)}
                                                    style={{
                                                        position: "relative",
                                                        border: roomForm.img === imgName ? "3px solid #2563eb" : "1px solid #e2e8f0",
                                                        padding: "6px",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        backgroundColor: roomForm.img === imgName ? "#eff6ff" : "#fff"
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        onClick={(e) => removeImageFromGallery(e, imgName)}
                                                        style={{ position: "absolute", top: "2px", right: "2px", backgroundColor: "#e74c3c", color: "white", border: "none", borderRadius: "50%", width: "20px", height: "20px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.65rem", cursor: "pointer", zIndex: 10 }}
                                                        title="Hapus"
                                                    >
                                                        <FaTrash />
                                                    </button>

                                                    <img
                                                        src={targetRoomId ? `/images/villas/villa_${form.id || '1'}/rooms/room_${targetRoomId}/${imgName}` : `/images/villas/villa_${form.id || '1'}/rooms/${imgName}`}
                                                        alt={imgName}
                                                        onError={(e) => {
                                                            const fallbackSrc = `/images/villas/villa_1/rooms/${imgName}`;
                                                            // Jika url src saat ini adalah fallbackSrc, berarti gambar benar-benar tidak ada
                                                            if (e.target.src.endsWith(fallbackSrc)) {
                                                                const parent = e.target.closest('.gallery-item');
                                                                if (parent) parent.style.display = 'none';
                                                            } else {
                                                                e.target.src = fallbackSrc;
                                                            }
                                                        }}
                                                        style={{ width: "100%", height: "65px", objectFit: "cover", borderRadius: "4px", marginBottom: "4px" }}
                                                    />
                                                    <span style={{ fontSize: "0.75rem", wordBreak: "break-all", display: "block", color: "#475569" }}>{imgName}</span>
                                                </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Nama Kamar *</label>
                                            <input
                                                type="text"
                                                name="bed_info"
                                                value={roomForm.bed_info || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: Kamar: Semeru Room"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Harga Per Malam (Rp) *</label>
                                            <input
                                                type="number"
                                                name="price"
                                                value={roomForm.price || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: 450000"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div style={{ marginTop: "10px" }}>
                                        <label style={{ fontWeight: "bold" }}>
                                            <FaMapMarkerAlt style={{ color: "#e74c3c", marginRight: "5px" }} />
                                            Lokasi / Alamat Kamar
                                        </label>
                                        <input
                                            type="text"
                                            name="location"
                                            value={roomForm.location || ""}
                                            onChange={handleRoomChange}
                                            placeholder="Contoh: Jl. Malioboro No. 1, Yogyakarta"
                                            style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                        />
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "10px" }}>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Kapasitas Tamu</label>
                                            <input
                                                type="text"
                                                name="max_guests"
                                                value={roomForm.max_guests || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: 4"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Jumlah Kamar</label>
                                            <input
                                                type="text"
                                                name="room_count"
                                                value={roomForm.room_count || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: 1"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Jumlah Kamar Mandi</label>
                                            <input
                                                type="text"
                                                name="bathroom_count"
                                                value={roomForm.bathroom_count || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: 1"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Tipe Kamar Mandi</label>
                                            <input
                                                type="text"
                                                name="bathroom_type"
                                                value={roomForm.bathroom_type || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: Shower, Bathtub"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Jam Operasional</label>
                                            <input
                                                type="text"
                                                name="hours"
                                                value={roomForm.hours || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Contoh: Check-in 14:00 | Check-out 12:00"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: "bold" }}>Deskripsi Kamar</label>
                                            <input
                                                type="text"
                                                name="description"
                                                value={roomForm.description || ""}
                                                onChange={handleRoomChange}
                                                placeholder="Tuliskan deskripsi singkat kamar"
                                                style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                        <label style={{ fontWeight: "bold" }}>Fasilitas Kamar (Pisahkan dengan koma)</label>
                                        <textarea
                                            name="facilities"
                                            value={roomForm.facilities || ""}
                                            onChange={handleRoomChange}
                                            placeholder="Contoh: Free Wifi, AC, TV"
                                            style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", minHeight: "60px" }}
                                        />
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        <label style={{ fontWeight: "bold" }}>Perlengkapan Kamar (Pisahkan dengan koma)</label>
                                        <textarea
                                            name="equipment"
                                            value={roomForm.equipment || ""}
                                            onChange={handleRoomChange}
                                            placeholder="Contoh: Handuk, Sabun, Sampo"
                                            style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", minHeight: "60px" }}
                                        />
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        <label style={{ fontWeight: "bold" }}>Amenities (Pisahkan dengan koma)</label>
                                        <textarea
                                            name="amenities"
                                            value={roomForm.amenities || ""}
                                            onChange={handleRoomChange}
                                            placeholder="Contoh: Kopi, Teh, Gula"
                                            style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", minHeight: "60px" }}
                                        />
                                    </div>

                                    {/* ===== LAYANAN TAMBAHAN (RENTAL & TRIP) ===== */}
                                    {roomForm.id && (
                                        <div style={{ marginTop: "24px", padding: "16px", backgroundColor: "#f0fdf4", borderRadius: "8px", border: "2px dashed #27ae60" }}>
                                            <h4 style={{ margin: "0 0 14px 0", color: "#166534", display: "flex", alignItems: "center", gap: "8px" }}>
                                                🚗 Layanan Tambahan Kamar Ini (Rental & Trip)
                                            </h4>

                                            {/* Form Tambah/Edit Addon */}
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: "8px", alignItems: "flex-end", marginBottom: "12px" }}>
                                                <div>
                                                    <label style={{ fontSize: "0.8rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>Kategori</label>
                                                    <select
                                                        value={addonForm.addon_type}
                                                        onChange={e => setAddonForm(p => ({ ...p, addon_type: e.target.value }))}
                                                        style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                                                    >
                                                        <option value="Motor">🏍️ Motor</option>
                                                        <option value="Mobil">🚗 Mobil</option>
                                                        <option value="Trip">🗺️ Trip / Paket Wisata</option>
                                                        <option value="Sepeda">🚲 Sepeda</option>
                                                        <option value="Lainnya">📦 Lainnya</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label style={{ fontSize: "0.8rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>Nama Layanan *</label>
                                                    <input
                                                        type="text"
                                                        value={addonForm.name}
                                                        onChange={e => setAddonForm(p => ({ ...p, name: e.target.value }))}
                                                        placeholder="Contoh: Honda Vario 125"
                                                        style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={{ fontSize: "0.8rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>Harga / Hari (Rp)</label>
                                                    <input
                                                        type="number"
                                                        value={addonForm.price}
                                                        onChange={e => setAddonForm(p => ({ ...p, price: e.target.value }))}
                                                        placeholder="Contoh: 100000"
                                                        style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={{ fontSize: "0.8rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>Keterangan (Opsional)</label>
                                                    <input
                                                        type="text"
                                                        value={addonForm.description}
                                                        onChange={e => setAddonForm(p => ({ ...p, description: e.target.value }))}
                                                        placeholder="Contoh: Termasuk helm"
                                                        style={{ padding: "8px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={saveAddon}
                                                    style={{ padding: "8px 14px", backgroundColor: addonEditIndex !== null ? "#2980b9" : "#27ae60", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer", whiteSpace: "nowrap" }}
                                                >
                                                    {addonEditIndex !== null ? "Update" : "+ Tambah"}
                                                </button>
                                            </div>

                                            {/* Daftar Addon */}
                                            {addonList.length === 0 ? (
                                                <p style={{ color: "#6b7280", fontSize: "0.85rem", margin: 0 }}>Belum ada layanan tambahan untuk kamar ini. Tambahkan di atas!</p>
                                            ) : (
                                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                                    {addonList.map((addon, idx) => (
                                                        <div key={addon.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "white", borderRadius: "6px", border: "1px solid #d1fae5" }}>
                                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                                <span style={{ fontSize: "0.75rem", backgroundColor: "#d1fae5", color: "#065f46", padding: "2px 8px", borderRadius: "99px", fontWeight: "600" }}>{addon.addon_type}</span>
                                                                <strong style={{ fontSize: "0.9rem" }}>{addon.name}</strong>
                                                                <span style={{ fontSize: "0.85rem", color: "#059669", fontWeight: "600" }}>Rp {Number(addon.price).toLocaleString("id-ID")}/hari</span>
                                                                {addon.description && <span style={{ fontSize: "0.8rem", color: "#6b7280" }}>— {addon.description}</span>}
                                                            </div>
                                                            <div style={{ display: "flex", gap: "6px" }}>
                                                                <button type="button" onClick={() => { setAddonEditIndex(idx); setAddonForm({ addon_type: addon.addon_type, name: addon.name, price: addon.price, description: addon.description || "" }); }} style={{ padding: "4px 10px", backgroundColor: "#2980b9", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "0.8rem" }}><FaEdit /></button>
                                                                <button type="button" onClick={() => deleteAddon(addon.id)} style={{ padding: "4px 10px", backgroundColor: "#e74c3c", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "0.8rem" }}><FaTrash /></button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                                        {selectedRoomIndex !== "" && (
                                            <>
                                                <button type="button" onClick={() => deleteRoomData(roomForm.id)} style={{ padding: "8px 14px", backgroundColor: "#e74c3c", color: "white", border: "none", borderRadius: "4px", fontWeight: "600", cursor: "pointer" }}>Hapus Kamar</button>
                                                <button type="button" onClick={resetRoomForm} style={{ padding: "8px 14px", backgroundColor: "#94a3b8", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}>Batal Edit</button>
                                            </>
                                        )}
                                        <button type="button" onClick={saveRoomData} style={{ padding: "10px 20px", backgroundColor: "#27ae60", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}><FaSave /> Simpan Kamar</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminManageVillas;